(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
        
  const atcObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {      
        if(entry.isIntersecting){
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.remove('active');
        } else {
          entry.target.closest('.product-wrapper').querySelector('.sticky-atc').classList.add('active');
        }
      });
    },
    {
      threshold: 0.25
    }
  );
  
  atcObserver.observe(document.querySelector('#AddToCartButton'));  
  document.querySelector('.sticky-atc').addEventListener('click', () => {
    document.querySelector('.product-form').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  })  


  if(document.querySelector('.gallery-zoom')){
    const zoom_container = document.querySelector('.gallery-zoom');  
  
    document.querySelectorAll('.product__media-item:not(.media-video)').forEach(item => {
      item.addEventListener('click', function(){
        let img = item.querySelector('img').src.replace('&width=1440', '&width=2048');    

        document.body.classList.add('drawer--open');    
        zoom_container.classList.add('gallery-zoom--active');
        zoom_container.querySelector('img').src = img;
      });
    });

    zoom_container.addEventListener('click', function(){      
      document.body.classList.remove('drawer--open');      
      zoom_container.classList.remove('gallery-zoom--active');
    });
  }  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;              
            }
          })
          .then(() => {
            setTimeout(() => {
              this.querySelector('.scroll-animation').classList.add('scroll-animation--active')
            }, 500)            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 100px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
